module.exports = __webpack_public_path__ + "img/電気回路_3_5_3.6d5aa4ac.png";